// extracted by mini-css-extract-plugin
export default {"themed-button":"ButtonMedal_themed-button__rqjmg"};